export default __webpack_public_path__ + "b8651aef2cd6dadc17df84e4a1ceb146.png";